export async function loadImage(src: string): Promise<HTMLImageElement> {
	return new Promise((resolve, reject) => {
		const image = new Image()
		image.crossOrigin = ''
		image.addEventListener('load', () => resolve(image))
		image.addEventListener('error', (error) => reject(error))
		image.src = src
	})
}

export async function loadVideo(src: string): Promise<HTMLVideoElement> {
	return new Promise((resolve, reject) => {
		const video = document.createElement('video')
		video.playsInline = true
		video.muted = true
		video.loop = true
		video.crossOrigin = ''
		video.addEventListener('loadedmetadata', () => resolve(video))
		video.addEventListener('error', (error) => reject(error))
		video.src = src
		video.load()
	})
}
